import { ApiBase } from './ApiBase';
class GiftsApiClientModel extends ApiBase {
    constructor() {
        super(...arguments);
        this.getGift = (pathParams) => {
            return this.get(`/v2/gifts/${pathParams.giftId}`);
        };
        this.getGifts = (queryParams) => {
            return this.get(`/v2/gifts/`, queryParams);
        };
        this.getGiftPackages = () => {
            return this.get(`/v2/gifts/packages`);
        };
        this.createGiftPackage = (payload) => {
            return this.post(`/v2/gifts`, payload);
        };
        this.getGiftPackage = (giftPackageId) => {
            return this.get(`/v2/gifts/packages/${giftPackageId}`);
        };
        this.deleteGiftPackage = (giftPackageId) => {
            return this.delete(`/v2/gifts/packages/${giftPackageId}`);
        };
        this.verifyMembershipGiftCheckout = (checkoutId) => {
            return this.get(`/v2/gifts/membership/checkout/${checkoutId}`);
        };
    }
}
export const GiftsApiClient = new GiftsApiClientModel();
